const useMax = (collection) => {
    let maxValue = 0;

    if(collection && collection.length>0)
        maxValue = Math.max(...collection.map( o => o.id ));

    return maxValue
}

export default useMax;